export default {
  'research.title': 'Research',
  'research.titleHighlight': 'History',
  'research.subtitle': 'Research achievements and awards history',

  // Awards
  'research.awards.title': 'Awards',

  // Publications
  'research.publications.title': 'Publications',
  'research.publications.international': 'International Conferences',
  'research.publications.domestic': 'Domestic Conferences',

  // Field labels
  'research.field.venue': 'Venue',
  'research.field.pages': 'Pages',
  'research.field.location': 'Location',
  'research.field.authors': 'Authors',
};
